// extracted by mini-css-extract-plugin
module.exports = {"vehicleMassLoad":"styles_vehicleMassLoad__3GSri","vehiclesForSales":"styles_vehiclesForSales__27LPw","vehicleMassLoadBackButtom":"styles_vehicleMassLoadBackButtom__3U-jc"};